import React from 'react';
import { Paper, Typography } from '@mui/material';

export interface ReportingScheduleProps {
  fundId: string | null;
  onScheduleUpdate: (schedule: any) => Promise<void>;
}

export const ReportingSchedule: React.FC<ReportingScheduleProps> = ({
  fundId,
  onScheduleUpdate
}) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Reporting Schedule
      </Typography>
      {/* Implement reporting schedule interface */}
    </Paper>
  );
}; 